import { Routes, Route, Navigate } from 'react-router-dom'
import AppLayout from './layout/AppLayout'
import AuthGuard from './components/AuthGuard'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Clients from './pages/Clients'
import ClientDetailPage from './pages/ClientDetailPage'
import ClientImportPage from './pages/ClientImportPage'
import OnboardingPage from './pages/OnboardingPage'
import Cases from './pages/Cases'
import CaseDetailPage from './pages/CaseDetailPage'
import Documents from './pages/Documents'
import Inbox from './pages/Inbox'
import Agenda from './pages/Agenda'
import Tasks from './pages/Tasks'
import Deadlines from './pages/Deadlines'
import Billing from './pages/Billing'
import InvoiceDetailPage from './pages/InvoiceDetailPage'
import NewInvoicePage from './pages/NewInvoicePage'
import PendingBillingPage from './pages/PendingBillingPage'
import JournalPage from './pages/ctb/JournalPage'
import LedgerPage from './pages/ctb/LedgerPage'
import TrialBalancePage from './pages/ctb/TrialBalancePage'
import ChartPage from './pages/ctb/ChartPage'
import AccountingPage, { LegacyBooksRedirect } from './pages/AccountingPage'
import Quotes from './pages/Quotes'
import QuoteEditorPage from './pages/QuoteEditorPage'
import Procurators from './pages/Procurators'
import Rates from './pages/Rates'
import AIAssistant from './pages/AIAssistant'
import OCR from './pages/OCR'
import Settings from './pages/Settings'
import SettingsLayout from './pages/settings/SettingsLayout'
import Profile from './pages/settings/Profile'
import Users from './pages/settings/Users'
import FirmPage from './pages/settings/Firm'
import ChannelsSettingsPage from './pages/settings/Channels'
import BillingSettingsPage from './pages/settings/Billing'
import EmailSettingsPage from './pages/settings/Email'
import LitigationSettingsPage from './pages/settings/Litigation'
import TemplatesSettingsPage from './pages/settings/Templates'
import EmailTemplatesSettingsPage from './pages/settings/EmailTemplates'
import VerifactuSettingsPage from './pages/settings/Verifactu'
import VerifactuDeclarationPage from './pages/settings/VerifactuDeclaration'
import RecurringSettingsPage from './pages/settings/Recurring'
import SecuritySettingsPage from './pages/settings/Security'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Gestión */}
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/import" element={<ClientImportPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/cases/:id" element={<CaseDetailPage />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/procuradores" element={<Procurators />} />
        <Route path="/inbox" element={<Inbox />} />

        {/* Agenda */}
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/deadlines" element={<Deadlines />} />

        {/* Administración */}
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/quotes/new" element={<QuoteEditorPage />} />
        <Route path="/quotes/:id" element={<QuoteEditorPage />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/billing/new" element={<NewInvoicePage />} />
        <Route path="/billing/pending" element={<PendingBillingPage />} />
        <Route path="/billing/books" element={<LegacyBooksRedirect />} />
        <Route path="/accounting" element={<Navigate to="/accounting/ledger" replace />} />
        <Route path="/accounting/:tab" element={<AccountingPage />} />
        <Route path="/ctb" element={<Navigate to="/ctb/journal" replace />} />
        <Route path="/ctb/journal" element={<JournalPage />} />
        <Route path="/ctb/ledger" element={<LedgerPage />} />
        <Route path="/ctb/trial-balance" element={<TrialBalancePage />} />
        <Route path="/ctb/accounts" element={<ChartPage />} />
        <Route path="/billing/:id" element={<InvoiceDetailPage />} />
        <Route path="/rates" element={<Rates />} />

        {/* IA */}
        <Route path="/ai" element={<AIAssistant />} />
        <Route path="/ocr" element={<OCR />} />

        <Route path="/settings" element={<SettingsLayout />}>
          <Route index element={<Settings />} />
          <Route path="profile" element={<Profile />} />
          <Route path="security" element={<SecuritySettingsPage />} />
          <Route path="users" element={<Users />} />
          <Route path="firm" element={<FirmPage />} />
          <Route path="billing" element={<BillingSettingsPage />} />
          <Route path="email" element={<EmailSettingsPage />} />
          <Route path="channels" element={<ChannelsSettingsPage />} />
          <Route path="litigation" element={<LitigationSettingsPage />} />
          <Route path="templates" element={<TemplatesSettingsPage />} />
          <Route path="email-templates" element={<EmailTemplatesSettingsPage />} />
          <Route path="verifactu" element={<VerifactuSettingsPage />} />
          <Route path="verifactu-declaration" element={<VerifactuDeclarationPage />} />
          <Route path="recurring" element={<RecurringSettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  )
}
